import React from "react";

export default function TermsAndConditions() {
  return (
    <>
      {/* ---- INLINE CSS ---- */}
      <style>{`
        /* Page Wrapper Animation */
        @keyframes fadeSlide {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .terms-wrapper {
          width: 100%;
          background: #ffffff;
          padding-top: 30px;
          padding-bottom: 40px;
        }

        .terms-container {
          width: 85%;
          max-width: 950px;
          margin: 40px auto;
          padding: 45px;
          border-radius: 20px;
          background: rgba(255, 255, 255, 0.75);
          backdrop-filter: blur(15px);
          box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.08);
          font-family: "Inter", sans-serif;
          animation: fadeSlide 0.7s ease-in-out;
          border: 1px solid #f0f0f0;
        }

        /* Heading Styling */
        .terms-title {
          text-align: center;
          font-size: 40px;
          font-weight: 900;
          background: linear-gradient(to right, #2a2a2a, #555);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 25px;
          letter-spacing: 0.4px;
        }

        .sub-heading {
          text-align: center;
          font-size: 18px;
          color: #555;
          margin-top: -10px;
          margin-bottom: 30px;
        }

        /* Highlight Card */
        .highlight-box {
          background: #f3f7ff;
          padding: 18px 22px;
          border-left: 6px solid #0066ff;
          border-radius: 14px;
          font-size: 16px;
          margin: 25px 0;
          box-shadow: 0 4px 15px rgba(0, 0, 150, 0.07);
        }

        /* Section Containers */
        .terms-section {
          margin-bottom: 32px;
          padding: 18px 10px;
          border-bottom: 1px solid #ebebeb;
          transition: all 0.3s ease;
        }

        .terms-section:hover {
          transform: translateX(4px);
        }

        .terms-section h3 {
          font-size: 24px;
          font-weight: 700;
          color: #222;
          margin-bottom: 10px;
        }

        .terms-section p {
          font-size: 16px;
          color: #555;
          line-height: 1.7;
        }

        /* List Styling */
        .terms-list {
          padding-left: 22px;
          margin-top: 10px;
        }

        .terms-list li {
          margin-bottom: 10px;
          color: #444;
          font-size: 16px;
          transition: 0.2s;
        }

        .terms-list li:hover {
          color: #000;
          transform: translateX(3px);
        }

        /* Footer Note */
        .footer-note {
          text-align: center;
          margin-top: 35px;
          font-size: 14px;
          color: #666;
        }

        @media (max-width: 700px) {
          .terms-container {
            width: 92%;
            padding: 25px;
          }
          .terms-title {
            font-size: 30px;
          }
          .terms-section h3 {
            font-size: 20px;
          }
        }
      `}</style>

      {/* ---- UI ---- */}
      <div className="terms-wrapper">
        <div className="terms-container">
          <h2 className="terms-title">Terms & Conditions</h2>
          <p className="sub-heading">Please read everything carefully before using Vyango</p>

          <div className="highlight-box">
            By using <strong>Vyango</strong>, you automatically accept these policies.
          </div>

          {/* Section 1 */}
          <div className="terms-section">
            <h3>1. Acceptance of Terms</h3>
            <p>
              By accessing Vyango, you acknowledge and accept all the terms listed here.  
              If you disagree with any condition, you should stop using the service immediately.
            </p>
          </div>

          {/* Section 2 */}
          <div className="terms-section">
            <h3>2. User Responsibilities</h3>
            <ul className="terms-list">
              <li>Provide accurate details for travel and identity.</li>
              <li>Use Vyango legally and responsibly.</li>
              <li>Respect privacy during chat, audio calls, and video calls.</li>
              <li>Maintain polite behavior with co-passengers and drivers.</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="terms-section">
            <h3>3. Ride Posting & Booking</h3>
            <p>
              Drivers must post correct ride information. Vyango does not verify each ride 
              or user, so passengers must check details before joining any ride.
            </p>
          </div>

          {/* Section 4 */}
          <div className="terms-section">
            <h3>4. Payments & Cancellations</h3>
            <p>
              Vyango does not manage payments. Any money exchanged between users 
              (fuel split, sharing cost, etc.) is strictly their own responsibility.
            </p>
          </div>

          {/* Section 5 */}
          <div className="terms-section">
            <h3>5. No Liability</h3>
            <p>
              Vyango is only a connecting link. We are not responsible for delays, disagreements,
              behavior, accidents, or anything that occurs during the shared ride.
            </p>
          </div>

          {/* Section 6 */}
          <div className="terms-section">
            <h3>6. Account & Privacy</h3>
            <p>
              Users must keep their accounts safe. Vyango ensures all chats and 
              communications are encrypted for your security.
            </p>
          </div>

          {/* Section 7 */}
          <div className="terms-section">
            <h3>7. Platform Restrictions</h3>
            <ul className="terms-list">
              <li>No illegal activities or rides allowed.</li>
              <li>Do not impersonate anyone.</li>
              <li>No harassment, spam, or misuse of communication tools.</li>
            </ul>
          </div>

          {/* Section 8 */}
          <div className="terms-section">
            <h3>8. Updates to Terms</h3>
            <p>
              These terms may be updated at any time. If you continue using Vyango, 
              it means you accept any changes made to the Terms & Conditions.
            </p>
          </div>

          <div className="highlight-box">
            For any questions or concerns, contact our Vyango support team.
          </div>
        </div>
      </div>
    </>
  );
}
